import { inject } from '@angular/core';
import { EntityCreatorService } from '@workbuddy/modules/creators';
import { ActivityContext, ActivityEmailConfig, readonlyActivityContext } from '../model';
import { ActivityService } from './activity.service';
import { UiActivityUtility } from '../utilities';
import { Activity, ActivityEntityName, ActivityKind, Attachment, QuotePro } from '@jms/model';
import * as Enumerable from 'linq';

export class ActivityEmailService {

    private creatorService = inject(EntityCreatorService);
    private activities = inject(ActivityService);

    public showEmailDialogForQuote(quote: QuotePro, attachments?: Attachment[]): Promise<Activity | undefined> {

        const job = Enumerable.from(quote.links).firstOrDefault(x => x.type === ActivityEntityName.Job);
        const opportunity = Enumerable.from(quote.links).firstOrDefault(x => x.type === ActivityEntityName.Opportunity);
        const customer = quote.account;
        const email = quote.contact?.email;

        const context = readonlyActivityContext(
            ActivityEntityName.QuotePro,
            quote._id,
            {
                right: {
                    manageActivity: true,
                    manageOtherUserActivity: false,
                    canModifySubmittedForm: false
                },
                job: job
                    ? { _id: job._id, name: job.name } as any
                    : null,
                opportunity: opportunity
                    ? { _id: opportunity._id, name: opportunity.name } as any
                    : null,
                customer: customer,
                includeEntityLink: true,
                showMarkSent: !quote?.sentDate,
                sendTo: email ? [email] : null,
                defaultAttachments: attachments,
                templateScopeRequest: {
                    companyIds: [quote.company?._id].filter(x => !!x),
                    jobTypes: [quote.jobType?._id].filter(x => !!x),
                }
            }
        );

        return this.showEmailDialog(context);
    }

    public showEmailDialog(context: ActivityContext, attachments?: Attachment[], emailConfig?: ActivityEmailConfig): Promise<Activity | undefined> {

        const activity = UiActivityUtility.buildActivityForKind(ActivityKind.Email, context);

        if (attachments?.length) {
            activity.attachments = [...attachments];
        }

        if (emailConfig?.activityLinks?.length) {
            activity.tags = emailConfig.activityLinks;
        }

        // The email editor reads report-attachment auto-gen config from context.emailConfig.
        const ctx = { ...context, emailConfig };

        return this.creatorService.show({
            entity: ActivityEntityName.Activity,
            config: { data: { activity, context: ctx, submit: (a) => this.activities.save(a) } },
        }).then(result => result.status === 'saved' ? result.activity : undefined);
    }

}
